import { useQuery } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";

export interface ProfitSummary {
  period_days: number;
  revenue_usd: number;
  cost_usd: number;
  gross_profit_usd: number;
  margin_pct: number;
  paying_users: number;
  free_users: number;
  avg_revenue_per_user: number;
  avg_cost_per_user: number;
}

export function useAdminProfitSummary(days: number) {
  return useQuery<ProfitSummary>({
    queryKey: ["admin", "profit-summary", days],
    queryFn: () =>
      apiClient.get("api/admin/profit/summary", { searchParams: { days } }).json(),
    retry: false,
  });
}

export interface UserProfit {
  user_id: string;
  name: string;
  plan: string;
  mrr_usd: number;
  cost_usd: number;
  gross_profit_usd: number;
  margin_pct: number;
}

export function useAdminProfitByUser(days: number) {
  return useQuery<{ period_days: number; users: UserProfit[] }>({
    queryKey: ["admin", "profit-by-user", days],
    queryFn: () =>
      apiClient.get("api/admin/profit/by-user", { searchParams: { days } }).json(),
    retry: false,
  });
}
